import React from "react";
import LogoGroupScroll from "../../Home Components/LogoGroupScroll";
import NCSLogo from "../../images/NCSLogo.png";
import B from "../../images/waves/BETA.png";
import A from "../../images/waves/ALPH.png";
import T from "../../images/waves/THETA.png";

import {
  Background,
  Container,
  Content,
  Video,
  Title,
  Text,
  Text2,
  Link,
  ExternalLink,
  TrainingSectionContainer,
  TrainingsContainer,
  TrainingContainer,
  TrainingHeader,
  TrainingTitle,
  StyledLink,
  BulletList,
  BulletListItem,
  ImageRowContainer,
  Image,

} from "./TrainingSectionElements"

const TrainingsData = [
  {
    name: "TRAINING",
    image: B,
    subtitle: "‘Change Your Mind Create New Results’",
    charity:"Charity 10% : The Mission Planet",
    text2:(<>Audience:<br/>Anyone interested in Dr Joe Dispenza's corporate training programme</>),
    bullets: [     
      "8 week programme",
      "2 x workbooks",
      "1 days training",
      "30 day action plan",
      "DASS21 Reporting",
      "Weekly coaching",
      ],
      link:"",
  },
  {
    name: "TRIALS",
    image: A,
    subtitle: "Data Capture",
    charity: "Charity 10% : The Mission Planet",
    text2:(<>Audience:<br/>- Corporate<br/>- Defence and Security<br/>- Sports</>),
    bullets: [
      "Performance",
      "Retention",
      "Recruitment",
      "Quantitative Analysis",
      "Qualitative Analysis",
    ],
      link:"",
  },
  {
    name: "TALKS",
    image: T,
    subtitle: (<><StyledLink href="/talks">View Talks</StyledLink></>),
    charity: "Charity 10% : The Mission Planet",
    text2:(<>Audience:<br/>- Key Note<br/>- Corporate leadership<br/>- Auction Prize (available upon request)<br/>[Testimonial: The ABF Charity chose the NEURO-leadership talk and raised £8k for their charity]</>),
    bullets: [
      "​Fly a Drone by Thought Alone​",
      "NEURO-Leadership​",

    ],
      link:"https://www.instagram.com/themissionplanet/",
  },
];

const TrainingSection = () => {
  return (
    <>
      <LogoGroupScroll />
      <Background>
      <Container>
        <Video
          src="https://www.youtube-nocookie.com/embed/0WdNQcDIBYE?rel=0?si=CbdVkOyXXVV3OE4e"
          frameBorder="0"
          allowFullScreen
        ></Video>
        <Content>
          <Title>Training Overview</Title>
          <Text>
            The training is based on the latest research in neuroscience and utilises a workshop that helps individuals and teams “change” from the inside out. Here is a short video explaining how it works.
          </Text>
          <Text>
            Our founder, is part of a global network of corporate consultants trained by Dr. Joe Dispenza, New York Times best-selling author, lecturer, and researcher. As a certified NeuroChangeSolutions consultant, Ellen educates businesses on the CYM CNR programme. It teaches organisations how to apply the neuroscience of change to increase employee engagement, collaboration, creativity, productivity, and ultimately business results.
          </Text>
          <Text>
            NCS consultants have worked with teams at Cisco, Sony, Coca-Cola, IBM, Johnson & Johnson, USAID, Rackspace, Microsoft, Pfizer, Heineken, and many more.
          </Text>
            <Text>
              Please click on the following link and see a copy of research from the National Library of Medicine, co-written by Dr Dispenza entitled 'Meditation-induced bloodborne factors as an adjuvant treatment’
              <ExternalLink
              href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC10432704/"
              target="_blank"
            >
              ncbi.nlm.nih.gov
            </ExternalLink>
          </Text>
      <ImageRowContainer>
        <Image src={NCSLogo} alt="NCSLogo" />
      </ImageRowContainer>
        </Content>
      </Container>
      <TrainingSectionContainer>
            <TrainingsContainer>
            {TrainingsData.map((project, index) => (
              <TrainingContainer key={index}>
                <TrainingHeader>{project.name}</TrainingHeader>
                  <TrainingTitle>{project.subtitle}</TrainingTitle>
                  {project.image && (
                    <img
                      src={project.image}
                      alt={project.name}
                      style={{
                        width: '100%',
                        height: 'auto',
                        marginTop: '10px',
                        paddingTop: '10px',
                        borderRadius: '40px',
                      }}
                    />
                  )}
                  <BulletList>
                  <ul>
                    {project.bullets.map((bullet, bulletIndex) => (
                      <BulletListItem key={bulletIndex}>{bullet}</BulletListItem>
                    ))}
                  </ul>
                <Text2>{project.text2}</Text2>
                <Text2>{project.text3}</Text2>
                {/* <Text2>{project.charity}</Text2> */}
                <Link href="https://www.instagram.com/themissionplanet/">{project.charity}</Link>
                </BulletList>
              </TrainingContainer>
            ))}
          </TrainingsContainer>
      </TrainingSectionContainer>
      {/* <ImageRowContainer>
        <Image src={Hereford} alt="People sat at table in training room" />
        <Image src={NCSLogo} alt="NCSLogo" />
        <Image src={NIH} alt="National Institutes of Health Logo" />
      </ImageRowContainer> */}
      </Background>
    </>
  );
};

export default TrainingSection;
